import http from "./http-common"
import {AuthResponse, Exercise, Useraccount} from "../types/domain";

/**
 * Service class for the Useraccount type
 * @author NSC
 */
class UseraccountService {
    url = `/useraccount/`;

    /**
     * Get Useraccount by login
     * @return Useraccount entity
     * @param data contains the login
     */
    checkLogin(data: { username: string, password: string }) {
        return http.post<AuthResponse>(this.url + `getByLoginData`, data);
    }

    /**
     * Get Useraccount by username
     * @param name username
     * @return Useraccount
     */
    getByName(name: string) {
        return http.get<Useraccount>(this.url + `getByUsername/${name}`)
    }

    /**
     * Gets all exercises for a user
     * @param id of the user
     */
    getExercises(id: number) {
        return http.get<Exercise[]>(this.url + `getExercises/${id}`);
    }

    getAll() {
        return http.get<Array<Useraccount>>(this.url + `getAll`);
    }

    /**
     * Create a user.
     * @param data user to create.
     */
    create(data: Useraccount) {
        return http.post<Useraccount>(this.url + `create`, data);
    }

    /**
     * Update a user.
     * @param data user to update.
     * @param id of the user.
     */
    update(data: Useraccount, id: number) {
        return http.put<Useraccount>(this.url + `${id}`, data);
    }

    /**
     * Reset user password
     * @param data user
     */
    resetPassword(data: Useraccount) {
        return http.post<Useraccount>(this.url + `resetPassword`, data);
    }
}

export default new UseraccountService();